import { CurrencyEnum } from '__generated__/types';
import { FlagSingapore } from '@xometry/icons';
import { LocaleEnum } from 'common/config/locales';
import { RegionData, Regions } from 'common/config/regions/types';
import { ENV } from 'common/constants/env';

export const SGRegionConfig: RegionData<Regions.SG> = {
  region: Regions.SG,
  currency: 'SGD' as unknown as CurrencyEnum,
  defaultLocale: LocaleEnum.EN,
  supportedLocales: [
    LocaleEnum.EN,
    LocaleEnum.TR,
    LocaleEnum.DE,
    LocaleEnum.ES,
    LocaleEnum.PL,
    LocaleEnum.FR,
    LocaleEnum.IT,
    LocaleEnum.EL,
    LocaleEnum.BG,
    LocaleEnum.RO,
    LocaleEnum.HU,
    LocaleEnum.CN,
    LocaleEnum.HI,
    LocaleEnum.CS,
    LocaleEnum.HR,
    LocaleEnum.LT,
    LocaleEnum.LV,
    LocaleEnum.SK,
    LocaleEnum.SL,
  ],
  supportEmail: 'provider@xometry.sg',
  productionSupportEmail: 'production@xometry.sg',
  supportPhone: '+61 (03) 8656 7081',
  icon: FlagSingapore,
  host: ENV.SG_HOST,
};
